import React from "react";

import * as Sentry from "@sentry/react";
import { Brand } from "@ds-developer/models";
import { makeStyles } from "@material-ui/core";
import { useParams } from "react-router-dom";

import { ErrorGeneric } from "@hubcapp/views";
import { Logo } from "@hubcapp/components";

import { FormCard } from "./components";

const useStyles = makeStyles(theme => ({
  root: {
    minHeight: "100vh",
    height: "100%",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    background: theme.palette.background.dark,
  },
  logo: {
    margin: `${theme.spacing(2)}px 0 0 ${theme.spacing(2)}px`,
  },
  main: {
    flex: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(4, 2, 4, 2),
  },
}));

const Auth: React.FC = ({ children }) => {
  const classes = useStyles();
  const { brand } = useParams<{ brand: string }>();
  return (
    <div className={classes.root}>
      <header>
        <Logo rootClass={classes.logo} />
      </header>
      <main className={classes.main}>
        <Sentry.ErrorBoundary
          fallback={
            <div style={{ flex: 1 }}>
              <ErrorGeneric />
            </div>
          }
        >
          <FormCard brand={brand === "bsm" ? Brand.Bsm : Brand.Aad}>
            {children}
          </FormCard>
        </Sentry.ErrorBoundary>
      </main>
    </div>
  );
};

export default Auth;
